import React from 'react';
import PropTypes from 'prop-types';

const ViewNavExtra = ({ children }) => <div>{children}</div>;

ViewNavExtra.propTypes = {
  children: PropTypes.node,
};

export default ViewNavExtra;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassHFv4/ViewNavCIC/ViewNavExtra/index.jsx